import * as z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { RepaymentPlanCancellationReason } from '../../../loan/WorkoutPlan';
import { zodBrandedUuid } from '../../../utils/Zod';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const CancelRepaymentWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('cancelRepaymentWorkoutPlan'),
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
  reason: RepaymentPlanCancellationReason,
  terminationDate: z.date(),
});
export type CancelRepaymentWorkoutPlanEvent = z.infer<typeof CancelRepaymentWorkoutPlanEvent>;
